import SubtleBadge from 'components/common/SubtleBadge';
import { flatRoutes } from 'helpers/utils';
import { useAppContext } from 'providers/AppProvider';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {
  configurationRoutes,
  contactsRoutes,
  customersRoutes,
  dashboardRoutes,
  financeRoutes,
  knowledgeBaseRoutes,
  ticketsRoutes
} from 'routes/siteMaps';
import NavbarDropdown from './NavbarDropdown';
import NavbarDropdownApp from './NavbarDropdownApp';
import NavbarDropdownModules from './NavbarDropdownModules';
import NavbarDropdownPages from './NavbarDropdownPages';

const NavbarTopDropDownMenus = () => {
  const {
    config: { navbarCollapsed, showBurgerMenu },
    setConfig
  } = useAppContext();

  const handleDropdownItemClick = () => {
    if (navbarCollapsed) {
      setConfig('navbarCollapsed', !navbarCollapsed);
    }
    if (showBurgerMenu) {
      setConfig('showBurgerMenu', !showBurgerMenu);
    }
  };
  return (
    <>
      <NavbarDropdown title="dashboard">
        {dashboardRoutes.children[0].children.map(route => (
          <Dropdown.Item
            key={route.name}
            as={Link}
            className={route.active ? 'link-600' : 'text-500'}
            to={route.to}
            onClick={handleDropdownItemClick}
          >
            {route.name}
          </Dropdown.Item>
        ))}
      </NavbarDropdown>

      <NavbarDropdown title="app">
        <NavbarDropdownApp items={ticketsRoutes.children} />
      </NavbarDropdown>

      <NavbarDropdown title="pages">
        <NavbarDropdownPages items={customersRoutes.children} />
      </NavbarDropdown>
      <NavbarDropdown title="modules">
        <NavbarDropdownModules items={contactsRoutes.children} />
      </NavbarDropdown>
      <NavbarDropdown title="knowledge base">
        {flatRoutes(knowledgeBaseRoutes.children).map(route => (
          <Dropdown.Item
            key={route.name}
            as={Link}
            className={route.active ? 'link-600' : 'text-500'}
            to={route.to}
            onClick={handleDropdownItemClick}
          >
            {route.name}
            {route.isNew && (
              <SubtleBadge bg="success" className="ms-2">
                BETA
              </SubtleBadge>
            )}
          </Dropdown.Item>
        ))}
      </NavbarDropdown>
      <NavbarDropdown title="finance">
        {flatRoutes(financeRoutes.children).map(route => {
          const showBadge = route.isNew === true;
          return (
            <Dropdown.Item
              key={route.name}
              as={Link}
              className={`${
                route.active ? 'link-600' : 'text-500'
              } d-flex align-items-center`}
              to={route.to}
              onClick={handleDropdownItemClick}
            >
              {route.name}
              {showBadge && (
                <SubtleBadge bg="success" className="ms-2">
                  BETA
                </SubtleBadge>
              )}
            </Dropdown.Item>
          );
        })}
      </NavbarDropdown>

      <NavbarDropdown title="setings">
        {flatRoutes(configurationRoutes.children).map(route => (
          <Dropdown.Item
            key={route.name}
            as={Link}
            className={route.active ? 'link-600' : 'text-500'}
            to={route.to}
            onClick={handleDropdownItemClick}
          >
            {route.name}
          </Dropdown.Item>
        ))}
      </NavbarDropdown>
    </>
  );
};

export default NavbarTopDropDownMenus;
